import { render, staticRenderFns } from "./AdminDevices.vue?vue&type=template&id=682c3208&scoped=true&"
import script from "./AdminDevices.vue?vue&type=script&lang=js&"
export * from "./AdminDevices.vue?vue&type=script&lang=js&"
import style0 from "./AdminDevices.vue?vue&type=style&index=0&id=682c3208&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682c3208",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('682c3208')) {
      api.createRecord('682c3208', component.options)
    } else {
      api.reload('682c3208', component.options)
    }
    module.hot.accept("./AdminDevices.vue?vue&type=template&id=682c3208&scoped=true&", function () {
      api.rerender('682c3208', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminDevices.vue"
export default component.exports